interface PropertyRowProps {
  propertyKey: string;
  displayName: string;
  displayValue: string;
}

export function PropertyRow({
  propertyKey,
  displayName,
  displayValue,
}: PropertyRowProps) {
  return (
    <p className="text-xs text-gray-600 font-normal">
      {displayName}:{' '}
      <span
        data-testid={'product-' + propertyKey}
        className="text-gray-900 font-medium"
      >
        {displayValue}
      </span>
    </p>
  );
}
